import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const getAssetsList = createAsyncThunk(
    "assetList/getAssetsList",
    async ({ page, limit }, { rejectWithValue }) => {
        try {
            const queryParams = new URLSearchParams({ page, limit });
            const response = await axiosHttp.get(`tms/assets?${queryParams}`);
            return response.data;
        } catch (err) {
            if (!err.response) throw err;
            return rejectWithValue(err.response.data);
        }
    }
);

const AssetListSlice = createSlice({
    name: "AssetListSlice",
    initialState: {
        isLoading: false,
        data: null,
        error: null,
        page: 1,
        total: 0,
    },
    reducers: {
        resetAssetList: (state) => {
            state.isLoading = false;
            state.data = null;
            state.error = null;
            state.page = 1;
            state.total = 0;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAssetsList.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAssetsList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload?.data?.docs || action.payload?.data || [];
                state.page = parseInt(action.payload?.data?.current_page) || action.payload?.data?.pagination?.page || 1;
                state.total = action.payload?.data?.total || action.payload?.data?.pagination?.total || 0;
            })
            .addCase(getAssetsList.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
});

export const { resetAssetList } = AssetListSlice.actions;
export default AssetListSlice.reducer;
